module.exports = __webpack_public_path__ + "static/img/chery_7@2x.50ed966.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/chery_7@2x.png
// module id = iHBj
// module chunks = 0